export default "__VITE_ASSET__WLv8kzel__"